// Cài đặt chụp — mô phỏng bảng điều khiển của booth ngoài hàng.

export const VIDEO_CONSTRAINTS = { width: 953, height: 599, facingMode: "user" };

// v2: mặc định đổi sang chụp tự động cả dải, giống booth ngoài hàng. Đổi khoá
// lưu trữ để bản mặc định mới có hiệu lực, thay vì bị bản v1 cũ đè lên.
export const STORAGE_KEY = "jiggleduo.capture.v2";

export const COUNTDOWN_OPTIONS = [3, 5, 10];
export const CANDIDATE_COUNT = 8; // chụp dư 8 tấm để chọn 4

export const DEFAULT_SETTINGS = {
    // Số giây đếm ngược. Ở chế độ tự động đây cũng chính là khoảng nghỉ giữa
    // hai tấm — chụp xong tấm này là đếm ngược lại ngay cho tấm sau.
    countdown: 5,
    shotMode: "auto", // "auto" (tự chụp cả dải) | "manual" (bấm từng tấm)
    mirror: true, // lật gương
    flash: true, // loé sáng lúc chụp
    pickBest: false, // chụp 8 chọn 4
    grid: false, // lưới canh khung
    sound: true, // tiếng bíp đếm ngược
    dateStamp: false // đóng dấu ngày lên ảnh
};

// Ghép với mặc định để cài đặt cũ lưu trong localStorage vẫn dùng được sau khi
// thêm tuỳ chọn mới, và để giá trị hỏng không làm sập giao diện.
export const normalizeSettings = raw => {
    const merged = { ...DEFAULT_SETTINGS, ...(raw && typeof raw === "object" ? raw : {}) };

    if (!COUNTDOWN_OPTIONS.includes(merged.countdown)) {
        merged.countdown = DEFAULT_SETTINGS.countdown;
    }
    if (merged.shotMode !== "auto" && merged.shotMode !== "manual") {
        merged.shotMode = DEFAULT_SETTINGS.shotMode;
    }

    return merged;
};
